import { useContext } from 'react';

import { NotificationsDispatchContext } from '@/modules/notifications/providers/NotificationsProvider.context';

export const useNotifications = () => useContext(NotificationsDispatchContext);
